import { AxiosResponse } from 'axios';
import { APIService } from '../../shared/services/APIService';
import { ScriptDTO } from '../dto/ScriptDTO';
import {Script} from "../models/Script";

export class AdminScriptsService extends APIService {

  //region GET
  /**
   * Get many scripts
   */
  getMany(): Promise<AxiosResponse<Script[]>> {
    return this.http.get<Script[]>('/scripts');
  }

  /**
   * Get all scripts with logs
   */
  getManyWithLogs(): Promise<AxiosResponse<Script[]>> {
    return this.http.get<Script[]>('/scripts/withLogs');
  }

  /**
   * Get the text of a script by name
   */
   getOne(name: string): Promise<AxiosResponse<string>>{
    return this.http.get<string>(`/scripts/${name}/text`);
  }

  /**
   * Get logs error of a script by name
   */
  getOneLogsError(name: string): Promise<AxiosResponse>{
    return this.http.get(`/scripts/${name}/logs`);
  }

  /**
   * Download a script by name
   */
  downloadOne(name: string) {
    return this.http.get<Blob>(`/scripts/${name}/download`, { responseType: 'blob' });
  }

  //endregion

  //region POST

  /**
   * Upload many scripts
   */
  uploadMany(files: File[]) {
    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file);
    }
    return this.http.post<void>(`/scripts/upload`, formData);
  }

  /**
   * Upload one script
   */
  uploadOne(dto: ScriptDTO) {
    return this.http.post<void>(`/scripts/uploadone`, dto);
  }

  uploadOneWithoutLogsError(name: string): Promise<AxiosResponse> {
    return this.http.post(`/scripts/${name}/logs`);
  }

  //endregion

  //region DELETE

  /**
   * Delete one script
   */
  deleteOne(name: string) {
    return this.http.delete<void>(`/scripts/${name}`);
  }

  //endregion

}
